export default __webpack_public_path__ + "static/media/Q4_2021_Art_Market_Report.dc47cf54.pdf";